import { render, staticRenderFns } from "./TeamDropdown.vue?vue&type=template&id=531ea6ad&scoped=true&"
import script from "./TeamDropdown.vue?vue&type=script&lang=js&"
export * from "./TeamDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TeamDropdown.vue?vue&type=style&index=0&id=531ea6ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ea6ad",
  null
  
)

export default component.exports